import { flowCashInCashOut } from "../../flowCashInCashOut";
import { flowDisabledLoan } from "../../flowDisabledLoan";
import { DISABLED_LOAN_STATUS } from "../constants/DisabledLoanStatus";

export const contractFlows = [
  {
    ...flowDisabledLoan,
    condition: (processState, authState) => {
      return DISABLED_LOAN_STATUS.includes(processState?.loan?.status);
    },
  },
  {
    ...flowCashInCashOut,
    condition: () => {
      return true;
    },
  },
];
